import { Collapse } from "antd";
import React, { useState } from "react";

const { Panel } = Collapse;

const RecommendationsNadNextSteps = (props) => {
  const [activeKeys, setActiveKeys] = useState([]);
  return (
    <>
      <div className="row faq-card-row recommendations-card">
        <div className="col-12">
          <Collapse
            defaultActiveKey={1}
            onChange={(key) => {
              setActiveKeys(key);
            }}
            activeKey={activeKeys}
            expandIcon={({ isActive }) => (
              <img
                src={`${
                  isActive
                    ? "/assets/images/icons/up-arrow-black.svg"
                    : "/assets/images/icons/down-arrow-balck.svg"
                }`}
                alt=""
                className="img-fluid"
              />
            )}
          >
            {props.children?.length > 0 &&
              props.children?.map((item, idx) => {
                const splittedstr =
                  item?.description.split(" ").slice(0, 35)?.join(" ") + "...";
                return (
                  <Panel
                    className="isactive"
                    header={
                      <>
                        <span className="ant-collapse-header-text">
                          {item?.title}
                        </span>
                        {!activeKeys.includes(String(idx + 1)) && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: splittedstr,
                            }}
                          ></div>
                        )}
                      </>
                    }
                    key={idx + 1}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.description }}
                    ></div>
                  </Panel>
                );
              })}
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default RecommendationsNadNextSteps;
